function ordenarPorFecha() {
  var grid = document.getElementById('product-grid') || document.querySelector('[id$="__product-grid"]');

  if (!grid) return;

  var items = Array.from(grid.querySelectorAll(':scope > li.grid__item'));
  if (items.length === 0) return;

  items.sort(function(a, b) {
    var wA = a.querySelector('[data-date]');
    var wB = b.querySelector('[data-date]');
    var dA = wA ? new Date(wA.getAttribute('data-date')) : new Date(9999, 0, 1);
    var dB = wB ? new Date(wB.getAttribute('data-date')) : new Date(9999, 0, 1);
    if (isNaN(dA)) dA = new Date(9999, 0, 1);
    if (isNaN(dB)) dB = new Date(9999, 0, 1);
    return dA - dB;
  });

  items.forEach(function(item) { grid.appendChild(item); });
}

function ejecutar() {
  ordenarPorFecha();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ejecutar);
} else {
  ejecutar();
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { ordenarPorFecha };
}


function ocultarPartidosPasados() {
 var grid = document.getElementById('product-grid') || document.querySelector('[id$="__product-grid"]');

  if (!grid) return;

  var hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  var items = grid.querySelectorAll(':scope > li.grid__item');
  items.forEach(function(li) {
    var el = li.querySelector('[data-date]');
    if (!el) return;
    var fecha = new Date(el.getAttribute('data-date'));
    if (!isNaN(fecha.getTime()) && fecha < hoy) {
      li.style.display = 'none';
    }
  });
}

function ejecutar() {
  ocultarPartidosPasados();
  ordenarPorFecha();
  ocultarPartidosPasados();
}


if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ejecutar);
} else {
  ejecutar();
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { ordenarPorFecha, ocultarPartidosPasados };
}
